import { actionTypes } from './actions';
import { initialState } from './initial';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };

    case actionTypes.GET_STATISTIC_PROVIDER:
      return {
        ...state,
        statisticProvider: { ...action.payload },
        actionProcessing: false,
      };

    case actionTypes.ACTIVE_USERS_PROCESSING:
      return {
        ...state,
        activeUsersStatistic: {
          ...state.activeUsersStatistic,
          isLoading: action.payload,
          ...(action.requestKey ? { requestKey: action.requestKey, data: null } : {}),
          ...(action.timeseriesKey ? { timeseriesKey: action.timeseriesKey, timeseries: null } : {}),
        },
      };

    case actionTypes.GET_ACTIVE_USERS_STATISTIC:
      return {
        ...state,
        activeUsersStatistic: { ...state.activeUsersStatistic, data: action.payload },
      };

    case actionTypes.GET_ACTIVE_USERS_TIMESERIES:
      return {
        ...state,
        activeUsersStatistic: { ...state.activeUsersStatistic, timeseries: action.payload },
      };

    case actionTypes.GET_REPORT_TIMESERIES:
      return {
        ...state,
        reportTimeseries: action.payload,
      };

    case actionTypes.GET_PROVIDER_TIMESERIES:
      return {
        ...state,
        providerTimeseries: action.payload,
      };

    case actionTypes.GET_PROVIDER_RANKS:
      return {
        ...state,
        providerRanks: action.payload,
      };

    case actionTypes.CLEAR_PROVIDER_DETAILS:
      return {
        ...state,
        providerTimeseries: {},
        providerRanks: initialState.providerRanks,
      };

    case actionTypes.GET_SAVED_FILTERS:
      return {
        ...state,
        savedFilters: action.payload,
      };

    case actionTypes.ADD_SAVED_FILTER:
      return {
        ...state,
        savedFilters: [action.payload, ...state.savedFilters],
      };

    case actionTypes.DELETE_SAVED_FILTER:
      return {
        ...state,
        savedFilters: state.savedFilters.filter(item => item.id !== action.payload),
      };

    case actionTypes.GET_PAYMENT_HISTORY:
      return {
        ...state,
        paymentHistory: action.payload,
        paymentHistoryTotals: {
          ...state.paymentHistoryTotals,
          lastCalculateTime: action.payload.details.lastCalculateTime,
        },
        actionProcessing: false,
      };

    case actionTypes.GET_PAYMENT_HISTORY_TOTAL:
      return {
        ...state,
        paymentHistoryTotals: action.payload,
        actionProcessing: false,
      };

    case actionTypes.GET_USER_STATISTICS:
      return {
        ...state,
        statisticPlayer: action.payload,
        actionProcessing: false,
      };

    case actionTypes.GET_SLOTS_HISTORY:
      return {
        ...state,
        slotsHistory: action.payload,
        actionProcessing: false,
      };

    case actionTypes.GET_BETS_HISTORY:
      return {
        ...state,
        betsHistory: action.payload,
        actionProcessing: false,
      };

    case actionTypes.GET_BET_INFO:
      return {
        ...state,
        betInfo: action.payload,
        actionProcessing: false,
      };

    case actionTypes.GET_PLAYER_DEPOSITS:
      return {
        ...state,
        playerDeposits: {
          data: action.payload.items,
          count: action.payload.count,
          cbu: state.playerDeposits.cbu,

          // differentCount:
          //   state.playerDeposits.count > action.payload.count
          //     ? state.playerDeposits.differentCount + 1
          //     : state.playerDeposits.differentCount,
        },
        actionProcessing: false,
      };

    // case actionTypes.SET_POLLING_FILTERS:
    //   return {
    //     ...state,
    //     playerDeposits: {
    //       ...state.playerDeposits,
    //       pollingFilters: action.payload,
    //     },
    //   };

    case actionTypes.GET_CBU:
      return {
        ...state,
        playerDeposits: {
          data: state.playerDeposits.data,
          count: state.playerDeposits.count,
          cbu: action.payload,
        },
        actionProcessing: false,
      };

    case actionTypes.GET_REQUEST_HISTORY:
      return {
        ...state,
        requestHistory: {
          data: action.payload.data,
          count: action.payload.count,
        },
      };

    case actionTypes.GET_CASHBACK_HISTORY:
      return {
        ...state,
        cashbackHistory: action.payload,
      };

    default:
      return state;
  }
}
